
<template>
  <div class="skeleton-wrapper">
    <v-card class="tournament-card-preview skeleton-card" v-for="n in 2" :key="'skel_card_'+n">
      <div class="tournament-card-header"><div class="skel-blob w-30"></div></div>
      <div class="tournament-card-events">
        <div class="grid-row" :style="dynamicGridStyle">
          <div class="grid-cell col-info"></div>
          <template v-for="m in (isSmallScreen ? 1 : maxMarkets)">
            <div class="grid-cell col-center" :key="'skel_head_'+m">
              <div class="inner-grid" style="display:grid; grid-template-columns: repeat(3, 1fr); gap:4px; width:100%"><div class="skel-box small"></div><div class="skel-box small"></div><div class="skel-box small"></div></div>
            </div>
          </template>
          <div class="grid-cell col-more"></div>
        </div>
        <div class="grid-row event-row" v-for="r in 3" :key="'skel_row_'+r" :style="dynamicGridStyle">
          <div class="grid-cell col-info">
            <div class="skel-blob w-60 mb-1"></div><div class="skel-blob w-50"></div>
          </div>
          <template v-for="m in (isSmallScreen ? 1 : maxMarkets)">
            <div class="grid-cell col-center" :key="'skel_cell_'+m">
              <div class="inner-grid" style="display:grid; grid-template-columns: repeat(3, 1fr); gap:4px; width:100%; height: 38px;"><div class="skel-box big"></div><div class="skel-box big"></div><div class="skel-box big"></div></div>
            </div>
          </template>
          <div class="grid-cell col-more" v-if="!isSmallScreen"><div class="skel-box big"></div></div>
        </div>
      </div>
    </v-card>
  </div>

</template>
<script>

export default {
  name: 'SkeletonPreview',
  props: {
    isSmallScreen: {
      type: Boolean,
      default: false
    }
  },
  data(){
    const winWidth = typeof window !== 'undefined' ? window.innerWidth : 1200;
    const isSmall = winWidth <= 600;
    return{
      maxMarkets: this.calculateMaxMarkets(winWidth),
      infoColWidth: this.calculateInfoColWidth(winWidth),
    }
  },
  methods:{
    calculateInfoColWidth(w) {
      if (w > 1350) return '350px';
      if (w > 1000) return '300px';
      if (w > 600) return '250px';
      return '110px';
    },
    calculateMaxMarkets(w) {
      if (w > 1350) return 3;
      if (w > 1000) return 2;
      return 1;
    },
  },
  computed:{
    dynamicGridStyle() {
      if (this.isSmallScreen) {
        return {
          'display': 'grid',
          'grid-template-columns': `minmax(0, 1fr) 175px `,
          'align-items': 'stretch',
          'border-bottom': '1px solid var(--skel-box-bg-2)',
          'width': '100%'
        };
      }
      return {
        'display': 'grid',
        'grid-template-columns': `${this.infoColWidth} repeat(${this.maxMarkets},  minmax(0px, 1fr)) 60px`,
        'align-items': 'stretch',
        'border-bottom': '1px solid var(--skel-box-bg-2)',
        'width': '100%'
      };
    },
  }
}

</script>

<style scoped>

/* FIX: min-height */

.grid-cell { display: flex; align-items: center; border-right: 1px solid var(--skel-box-bg); height: 100%; padding: 0 5px; }
.col-info { padding: 0 10px; justify-content: space-between; cursor: pointer; border-right: 1px solid var(--skel-box-bg-2); }
.col-center { justify-content: center; }
.col-more { justify-content: center; border-right: none; }

.team-name span { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
@media (hover: hover) and (pointer: fine) { .event-row .col-info:hover .competitors-block { color: var(--color-accent); } }



.skeleton-wrapper { min-height: 200px; width: 100%; }
@keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
.skel-blob, .skel-box, .skel-circle { background: var(--skel-box-bg); background-image: var(--skel-box); background-size: 200% 100%; animation: shimmer 1.5s infinite linear; border-radius: 4px; }
.skel-blob { height: 10px; display: block; }
.skel-circle { width: 14px; height: 14px; border-radius: 50%; background: var(--skel-box-bg-2); flex-shrink: 0; }
.skel-box.small { height: 10px; width: 80%; margin: 0 auto; background: var(--skel-box-bg-2); }
.skel-box.big { height: 100%; width: 100%; border-radius: 3px; border: 1px solid var(--skel-box-bg-2); }
.w-10 { width: 10%; min-width: 40px; } .w-30 { width: 30%; min-width: 100px; } .w-50 { width: 50%; } .w-60 { width: 60%; }
.skeleton-card { pointer-events: none; opacity: 0.9; }

.cell-content .outcome-name { font-size: var(--font-size-md); color: #aaa; line-height: 1; text-transform: uppercase; letter-spacing: 0.3px; }
.cell-content .outcome-value { font-size: var(--font-size-3xl); font-weight: 700; color: var(--color-accent); line-height: 1; }
.odd_selected .cell-content .outcome-name,
.odd_selected .cell-content .outcome-value { color: #fff !important; }
.tournament-card-header{
  background: var(--bg-card);
}
.event-row{
  border-radius: 0;
  margin-bottom: 0;
}
</style>